import { useState } from "react";
import useWexClient from "./Clients/wexClient,";

const useClass = () => {
  const { createClass } = useWexClient();
  const [loaderClass, setLoaderClass] = useState(false);

  const createNewClass = async (body = {}) => {
    setLoaderClass(true);
    try {
      const response = await createClass(body);
      setLoaderClass(false);
      return response;
    } catch (err) {
      setLoaderClass(false);
      throw (err);
    }
  };

  return {
    createNewClass,
    loaderClass
  };
};

export default useClass;